"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgHideFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m5.743 7.155-3.45-3.45a.998.998 0 0 1 0-1.413 1 1 0 0 1 1.415.001l18 18.003a.998.998 0 0 1-.001 1.412 1 1 0 0 1-1.415-.001l-3.745-3.746C15.15 18.654 13.635 19 12 19c-3.893 0-7.11-1.92-9.652-5.758a2 2 0 0 1-.026-2.168c1.03-1.637 2.17-2.943 3.421-3.919Zm3.55 3.55a3 3 0 0 0 4.001 4.002l-4.001-4.001Zm10.463 4.837L9.511 5.296A10.302 10.302 0 0 1 12 5c3.9 0 7.121 1.972 9.665 5.916a2 2 0 0 1 0 2.168 16.71 16.71 0 0 1-1.91 2.458Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgHideFilled);
//# sourceMappingURL=SvgHideFilled.js.map